export const isCampaignEnded = (campaignEndsAt: number | null): boolean =>
  typeof campaignEndsAt === 'number' && campaignEndsAt > 0 && Date.now() > campaignEndsAt;

const getSpinStorageKey = (participantKey: string) =>
  `wheel-of-fortune:spin-count:${participantKey.trim().toLowerCase()}`;

export const getSpinCount = (participantKey: string): number => {
  if (!participantKey || typeof window === 'undefined') {
    return 0;
  }

  try {
    const saved = window.localStorage.getItem(getSpinStorageKey(participantKey));
    return saved ? Number.parseInt(saved, 10) || 0 : 0;
  } catch (error) {
    console.warn('Unable to read spin count from localStorage:', error);
    return 0;
  }
};

export const hasReachedMaxSpins = (
  participantKey: string,
  maxSpinsPerUser: number
): boolean => {
  if (!participantKey || maxSpinsPerUser <= 0) {
    return false;
  }

  return getSpinCount(participantKey) >= maxSpinsPerUser;
};

export const incrementSpinCount = (participantKey: string): number => {
  const nextCount = getSpinCount(participantKey) + 1;

  if (!participantKey || typeof window === 'undefined') {
    return nextCount;
  }

  try {
    window.localStorage.setItem(getSpinStorageKey(participantKey), String(nextCount));
  } catch (error) {
    console.warn('Unable to persist spin count in localStorage:', error);
  }

  return nextCount;
};
